import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Loading data from the API", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["width", "height", "stroke"]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1 1)\" stroke-width=\"2\"><circle stroke-opacity=\".25\" cx=\"18\" cy=\"18\" r=\"18\"></circle><path d=\"M36 18c0-9.94-8.06-18-18-18\"><animateTransform attributeName=\"transform\" type=\"rotate\" from=\"0 18 18\" to=\"360 18 18\" dur=\"0.8s\" repeatCount=\"indefinite\"></animateTransform></path></g></g>", 1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.msgSpinner !== null || _ctx.msgSpinner !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.msgSpinner), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4)),
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 38 38",
      xmlns: "http://www.w3.org/2000/svg",
      width: _ctx.width,
      height: _ctx.height,
      stroke: _ctx.color
    }, _hoisted_7, 8, _hoisted_5))
  ], 64))
}